import {createAsyncThunk} from '@reduxjs/toolkit'

import {openNewTab} from '@web/helpers/browser'

import {ThunkApi} from '../interfaces'

const HAPPY_MONEY_ID_FINDING_URL = `http://www.happymoney.co.kr/svc/find/findId.hm`

/**
 * 해피머니 상품권 로그인 정보찾기 페이지로 이동
 */
const navigateToHappyMoneyIdFinding = createAsyncThunk<Promise<string | unknown>, void, ThunkApi>(
    'navigateTo/happyMoneyIdFinding',
    async () => {
        openNewTab({url: HAPPY_MONEY_ID_FINDING_URL})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    },
)

export default navigateToHappyMoneyIdFinding
